import { keyframes } from 'styled-components'
import { styled } from '../theme'
import { colors } from '../theme/colors'

export type SpinnerSize = 'm' | 'xl'

interface Props {
  size?: 'm' | 'xl'
}

export const Wrapper = styled.span.attrs({})<Props>`
  width: 100%;
  display: block;
  position: relative;
  overflow: hidden;

  width: ${props => props.size === 'm' && '80px'};
  max-width: ${props => props.size === 'xl' && '180px'};
  min-width: ${props => props.size === 'xl' && '80px'};
`

const spinAnimation = keyframes`
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`

export const InnerWrapper = styled.span`
  width: 100%;
  padding-top: 100%;
  height: 0;
  transform-origin: 50% 50%;
  animation: ${spinAnimation} 3s linear infinite;
  display: block;
`

const Line = styled.span`
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;

  :before {
    content: '';
    width: 100%;
    height: 100%;
    border-color: transparent;
    border-style: solid;
    border-width: 3px;
    border-radius: 50%;
    position: absolute;
    left: 79%;
    top: 0;
  }
`

export const PrimaryLine = styled(Line)`
  transform: scale(0.99) rotate(0deg) translate(-79%, 0);

  :before {
    border-color: ${colors.primary};
  }
`

export const SecondaryLine = styled(Line)`
  transform: scale(0.99) rotate(120deg) translate(-79%, 0);

  :before {
    border-color: ${colors.secondary};
  }
`

export const TernaryLine = styled(Line)`
  transform: scale(0.99) rotate(240deg) translate(-79%, 0);

  :before {
    border-color: ${colors.ternary};
  }
`
